module.exports = __webpack_public_path__ + "static/img/20013 (2).8c084f6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20013 (2).webp
// module id = YuOu
// module chunks = 14